(function () {
  function initTestimonialSliders() {
    if (typeof Swiper === 'undefined') return;

    document.querySelectorAll('[data-iw-testimonial-slider]').forEach((root) => {
      if (root.dataset.iwTestimonialInitialized === 'true') return;

      const swiperEl = root.querySelector('.iw-testimonial__swiper');
      const paginationEl = root.querySelector('.iw-testimonial__swiper-pagination');

      if (!swiperEl) return;

      new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 20,
        watchOverflow: true,
        breakpoints: {
          750: {
            slidesPerView: 2,
            spaceBetween: 22,
          },
          900: {
            slidesPerView: 3,
            spaceBetween: 22,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 22,
          },
        },
        pagination: {
          el: paginationEl,
          clickable: true,
        },
      });

      root.dataset.iwTestimonialInitialized = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTestimonialSliders);
  } else {
    initTestimonialSliders();
  }

  document.addEventListener('shopify:section:load', initTestimonialSliders);
})();
